/**
 * The Team tab's Onboarding sub-view addresses (plan docs/plans/lms-plan.md
 * 18.3: Team sub-view path "onboarding", mounted under onboarding/* so this
 * sub-view routes its own run page; WP-47).
 */

/** The run list: /lms/team/onboarding */
export const RUNS_BASE = '/lms/team/onboarding';

/** One run: /lms/team/onboarding/<runId> */
export function runHref(runId: string): string {
  return `${RUNS_BASE}/${encodeURIComponent(runId)}`;
}

/** The template list under Manage (12.1), where a missing template is made. */
export const TEMPLATES_HREF = '/lms/manage/onboarding-templates';

/**
 * One choice out of a multi-select picker's answer (the UserPicker and the
 * SitePicker are multi-select, WP-43): the newly added id, else the current
 * one while it is still chosen, else none.
 */
export function pickSingle(ids: string[], current: string | null): string | null {
  const added = ids.filter((id) => id !== current);
  if (added.length > 0) return added[added.length - 1];
  return current !== null && ids.includes(current) ? current : null;
}
